import React from 'react';
import { RobotOutlined } from '@ant-design/icons';
import { Avatar as AntAvatar } from 'antd';
import {
  TypingIndicatorContainer,
  AvatarWrapper,
  TypingDots,
  Dot
} from 'src/styled/Chat/MessageBubble.styled';

export const TypingIndicator: React.FC = () => {
  // Get favicon URL from document
  const getFaviconUrl = () => {
    if (typeof window === 'undefined') return '/favicon.ico';
    const favicon = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
    return favicon?.href || '/favicon.ico';
  };

  return (
    <TypingIndicatorContainer>
      <AvatarWrapper className="bot-avatar">
        <AntAvatar
          src={getFaviconUrl()}
          icon={<RobotOutlined />}
          size={32}
          style={{
            background: '#ffffff',
            color: '#1F2D3A'
          }}
        />
      </AvatarWrapper>
      <TypingDots>
        <Dot delay={0} />
        <Dot delay={0.2} />
        <Dot delay={0.4} />
      </TypingDots>
    </TypingIndicatorContainer>
  );
};

export default TypingIndicator;
